import styled from "styled-components";
import { theme } from "styles/theme";

export const SensorGridContainer = styled.div<{ $hasAlarm: boolean }>`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 1px;
  margin: 12px 0;
  padding: 0;
  border-radius: 0;
  border: none;
  background-color: ${theme.colors.border};
  overflow: hidden;
`;

export const SensorCell = styled.div<{ connected: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 12px 8px;
  background-color: ${(props) => (props.connected ? theme.colors.surface : theme.colors.grey)};
  opacity: ${(props) => (props.connected ? 1 : 0.7)};
`;

export const SensorLabel = styled.span`
  font-size: 0.75rem;
  color: ${theme.colors.darkGrey};
  margin-bottom: 4px;
`;

export const SensorValue = styled.span`
  font-weight: ${theme.fontWeights.bold};
  font-size: 0.9rem;
`;
